<div class="card">
  <div class="card-content">
    <form (submit)="onSubmit($event)">
      <h4
        class="is-size-5"
        style="
          margin-bottom: 15px;
          text-align: center;
          text-transform: uppercase;
        "
      >
        {{ 'LOGIN' | translate }}
      </h4>
      <div class="field" *ngIf="!twoFactorVerificationCodeSent">
        <div class="control has-icons-left has-icons-right">
          <input
            (input)="handleFieldChange($event)"
            class="input"
            type="email"
            name="email"
            [ngClass]="{ 'is-danger': hasError('email') }"
            [placeholder]="'EMAIL' | translate"
          />
          <span class="icon is-small is-left">
            <i class="fas fa-envelope"></i>
          </span>
        </div>
        <p class="help is-danger" *ngIf="hasError('email')">
          {{ getError('email') }}
        </p>
      </div>

      <div class="field" *ngIf="twoFactorVerificationCodeSent">
        <div class="control has-icons-left">
          <input
            (input)="handleFieldChange($event)"
            name="twoFactorCode"
            type="text"
            class="input"
            [ngClass]="{ 'is-danger': hasError('twoFactorCode') }"
            [placeholder]="'TWO_FACTOR_CODE' | translate"
          />
          <span class="icon is-small is-left">
            <i class="fas fa-lock"></i>
          </span>
        </div>
        <p class="help is-danger" *ngIf="hasError('twoFactorCode')">
          {{ getError('twoFactorCode') }}
        </p>
      </div>

      <div class="timer" *ngIf="twoFactorVerificationCodeSent && !codeExpired">
        {{ 'THE_CODE_WILL_EXPIRE_IN' | translate }}
        <strong>{{ validityTime | countdown : 'mm:ss' }}</strong>
      </div>

      <div class="timer" *ngIf="twoFactorVerificationCodeSent && codeExpired">
        {{ 'THE_CODE_HAS_EXPIRED' | translate }}.
        <a (click)="loginAgain()">{{ 'LOGIN_AGAIN' | translate }}</a
        >.
      </div>

      <div class="field" *ngIf="!twoFactorVerificationCodeSent">
        <div class="control has-icons-left is-relative">
          <input
            (input)="handleFieldChange($event)"
            name="password"
            [type]="passwordVisible ? 'text' : 'password'"
            class="input"
            [ngClass]="{ 'is-danger': hasError('password') }"
            [placeholder]="'PASSWORD' | translate"
          />
          <span class="icon is-small is-left">
            <i class="fas fa-lock"></i>
          </span>
        </div>
        <p class="help is-danger" *ngIf="hasError('password')">
          {{ getError('password') }}
        </p>
        <div class="is-flex forgot-password">
          <a [routerLink]="['/auth/password-reset']"
            >{{ 'FORGOT_PASSWORD' | translate }}?</a
          >
        </div>
      </div>

      <button
        class="button is-fullwidth is-link is-outlined"
        type="submit"
        [disabled]="isLoading"
      >
        {{ (twoFactorVerificationCodeSent ? 'CONTINUE' : 'LOGIN') | translate }}
      </button>
    </form>
  </div>
</div>
